import React, { useState } from 'react';
import { useQuery } from 'react-query';
import * as Styles from 'components/manage-vm/settings-panel/SettingsPanel.style';
import CustomButton from 'components/common/custom-button';
import { Grid } from '@mui/material';
import Select from 'components/select';
import { filteredIsoForSelect } from 'components/manage-vm/utils';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import { P } from 'components/reusable-css';

const ReinstallWithIos = ({ kvm_url, loading, refreshServer, manageVmId, data }) => {
  const { t } = useTranslation();
  const { data: iso } = useQuery(`/vs/iso/${manageVmId}`, {
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
  const filterTOSelect = filteredIsoForSelect(iso);
  const [selectedValue, setSelectedValue] = useState(filterTOSelect[0]?.value);
  const buttonStyle = { marginTop: '10px', padding: '14px 15px' };

  const handleConsoleOpen = () => {
    if (kvm_url) window.open(kvm_url, '_blank', 'toolbar=0,status=0,width=1150,height=800,resizable=0');
  };
  return (
    <Styles.ActionDiv>
      <Styles.SelectName>
        <Grid container spacing={0}>
          {data?.loading_iso == '' && (
            <Grid style={{ marginRight: '5px' }}>
              <Select
                style={{ marginTop: '10px', width: '100%' }}
                value={selectedValue}
                options={filterTOSelect}
                name="iso"
                onChange={(e) => {
                  setSelectedValue(e.target.value);
                }}
              />
            </Grid>
          )}
          <Grid>
            <CustomButton
              buttonStyles={buttonStyle}
              title={data?.loading_iso == '' ? 'vs/instance.string214' : 'vs/instance.string222'}
              isLoading={loading}
              onClick={() =>
                refreshServer(
                  data?.loading_iso == '' ? 'mountiso' : 'unmountiso',
                  data?.loading_iso == '' && { iso: selectedValue ? selectedValue : filterTOSelect[0]?.value },
                )
              }
            />
          </Grid>
        </Grid>
      </Styles.SelectName>
      {data?.loading_iso == '' && (
        <Styles.DestroyText>
          <P>{t('vs/instance.string215')}</P>
        </Styles.DestroyText>
      )}
      <Styles.DestroyText>
        <P>
          {t('vs/instance.string216')}
          <span>
            <Icon size="large" name="keyboard outline" onClick={handleConsoleOpen} />
          </span>
        </P>
      </Styles.DestroyText>
      <Styles.DestroyText>
        <P>{t('vs/instance.string220')}</P>
      </Styles.DestroyText>
    </Styles.ActionDiv>
  );
};

export { ReinstallWithIos };
